import { motion } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';
import styles from './SuccessMessage.module.css';

interface SuccessMessageProps {
  onClose: () => void;
}

export function SuccessMessage({ onClose }: SuccessMessageProps) {
  return (
    <motion.div
      className={styles.overlay}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        className={styles.modal}
        initial={{ scale: 0.8, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.8, opacity: 0, y: 20 }}
        transition={{ type: "spring", stiffness: 200, damping: 20 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className={styles.closeButton} onClick={onClose}>
          <X size={20} />
        </button>

        <motion.div
          className={styles.iconWrapper}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
        >
          <CheckCircle className={styles.icon} size={48} />
        </motion.div>

        <motion.h2
          className={styles.title}
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Message Sent Successfully!
        </motion.h2>

        <motion.p
          className={styles.message}
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          Thank you for reaching out to SFrays! We've received your message and our team will get back to you within 24 hours.
        </motion.p>

        <motion.p
          className={styles.subMessage}
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          We're excited to learn more about your project and explore how we can work together to bring your vision to life.
        </motion.p>

        <motion.div
          className={styles.checkmark}
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          <p className={styles.checkmarkText}>✓ Confirmation email sent to your inbox</p>
          <p className={styles.checkmarkText}>✓ Ticket created in our system</p>
          <p className={styles.checkmarkText}>✓ Team member assigned to your inquiry</p>
        </motion.div>

        <motion.button
          className={styles.closeActionButton}
          onClick={onClose}
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.7 }}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          Got it, thanks!
        </motion.button>
      </motion.div>
    </motion.div>
  );
}
